<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" v-if="informText != ''">
          <v-alert type="error">
            {{ informText }}
          </v-alert>
        </v-col>

        <v-col cols="12" class="border">
          <v-row>
            <v-col cols="8" style="text-align: left">
              <v-icon>mdi-file-upload-outline</v-icon>
              <template v-if="selectedFileData.fileName == ''">
                &nbsp; No File Selected</template
              >
              <template
                v-else
                v-for="(value, text, index) in this.selectedFileData"
              >
                {{ text }} : {{ value }}<br :key="index" />
              </template>
            </v-col>
            <v-col cols="4" style="text-align: right">
              <input
                type="file"
                @change="onFileSelected"
                ref="inputPreview"
                style="display: none"
              />
              <v-btn
                small
                :loading="loading"
                :disabled="loading"
                color="blue-grey"
                class="white--text"
                @click="$refs.inputPreview.click()"
                v-if="!loadBtn"
              >
                Import Raw Order File
                <v-icon right dark>mdi-calendar-import</v-icon>

                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>mdi-loading</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-btn
                small
                color="blue-grey"
                class="white--text"
                v-else
                disabled
              >
                Import Raw Order File
                <v-icon right dark>mdi-calendar-import</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-btn
            small
            class="white--text"
            :loading="loading2"
            :disabled="loading2"
            color="deep-purple darken-1"
            @click="
              loader = 'loading2';
              uploadData();
            "
            v-if="arrayData.length > 0"
          >
            Upload Data
            <v-icon right dark>mdi-cloud-upload</v-icon>
            <template v-slot:loader>
              <span style="color: black">{{ percent }} %</span>
            </template>
          </v-btn>

          <v-btn
            small
            class="white--text"
            color="deep-purple darken-1"
            v-else
            disabled
            >Upload Data <v-icon right dark>mdi-cloud-upload</v-icon></v-btn
          >

          &nbsp;

          <v-btn
            small
            class="white--text"
            color="warning"
            @click="cancelData"
            v-if="loader == null"
          >
            Cancel <v-icon right dark>mdi-window-close</v-icon>
          </v-btn>
          <v-btn small class="white--text" color="warning" v-else disabled>
            Cancel <v-icon right dark>mdi-window-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import Amplify, { Auth } from "aws-amplify";
import VuePapaParse from "vue-papa-parse";
import Vue from "vue";
Vue.use(VuePapaParse);

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "PreprocessingOrder",

  data: () => ({
    loader: null,
    loading: false,
    loading2: false,
    loadBtn: false,
    selectedFile: [],
    arrayData: [],
    AuthStr: "",
    percent: "",
    total_orders: "",
    selectedFileData: {
      fileName: "",
      fileSize: "",
    },
    link: window.domain + "orders/preprocess-orders",
    timeStamp: "",
    informText: "",
    checkHeader: [
      "Order Name",
      "Order ID",
      "Customer First Name",
      "Customer Last Name",
      "Customer Email",
      "Customer Phone",
      "Created At",
      "Financial Status",
      "Lineitem Name",
      "Lineitem Product Type",
      "Lineitem Variant Option 1",
      "Lineitem Variant Option 2",
      "Lineitem Variant Option 3",
      "Lineitem Quantity",
      "Lineitem SKU",
      "Vendor Code",
      "Design Link",
      "Link Error Note",
      "Shipping First Name",
      "Shipping Last Name",
      "Shipping Phone",
      "Shipping Address1",
      "Shipping Address2",
      "Shipping Company",
      "Shipping City",
      "Shipping Province Code",
      "Shipping Country Code",
      "Shipping Zip",
      "Subtotal",
      "Taxes",
      "Lineitem Price",
      "Lineitem Discount",
      "Lineitem Total Price",
      "Discount Amount",
      "Shipping Lines Prices",
      "Shipping Lines Total Price",
      "Total",
      "Lineitem Product Tags",
      "Lineitem Properties",
      "Payment Gateway Names",
      "Referring Site",
      "Note Attributes",
      "Lineitem ID",
      "Lineitem Product Handle",
      "Lineitem Vendor",
      "Lineitem Fulfillment Service",
      "Landing Site",
      "Lineitem Product ID",
      "Transactions Authorization Codes",
      "Transactions Gateway Names",
    ],
  }),

  methods: {
    onFileSelected(event) {
      console.log("onFileSelected click");
      this.loader = "loading";
      this.informText = "";
      this.selectedFile = [];
      this.selectedFile = event.target.files || event.dataTransfer.files;
      if (!this.selectedFile.length) return;

      this.selectedFileData.fileName = this.selectedFile[0].name;
      this.selectedFileData.fileSize = this.selectedFile[0].size + " bytes";
      this.timeStamp =
        Date.now().toString() + Math.floor(Math.random() * 10).toString();
      console.log(this.selectedFile[0]);
      this.createInput(this.selectedFile[0]);
    },

    createInput(file) {
      this.arrayData = [];
      const l = this.loader;
      this[l] = !this[l];
      console.log("createInput click");
      let promise = new Promise((resolve) => {
        var reader = new FileReader();
        var vm = this;
        reader.onload = (e) => {
          //console.log(e)
          e;
          resolve((vm.fileinput = reader.result));
        };
        reader.readAsText(file);
      });

      promise.then(
        (result) => {
          result;
          var lines = this.fileinput.split("\n");

          var a = lines[0].split(",");
          var headers = [];
          for (const i of a) {
            headers.push(i.toString().trim());
          }

          console.log(headers);
          // var check1 = false

          // for(const a of headers){
          //     if(a == "System Short Note"){
          //         check1 = true
          //         break;
          //     }else{
          //         check1 = false
          //     }
          // }

          // for (const a of this.checkHeader) {
          //   if (!headers.includes(a)) {
          //     console.log(a);
          //     this[l] = false;
          //     this.loader = null;
          //     return (this.informText =
          //       "The selected file is not correct format (Losing field:'" +
          //       a +
          //       "'). Please choose again.");
          //   }
          // }

          for (var i = 1; i < lines.length; i++) {
            if (lines[i] != "") {
              var obj = {};
              var currentline = this.$papa.parse(lines[i]).data[0];
              for (var j = 0; j < headers.length; j++) {
                console.log("j: ", currentline[j]);
                obj[headers[j]] = currentline[j].toString();
              }
              this.arrayData.push(obj);
            }
          }
          console.log(this.arrayData.length);
          this.addOrderNumber();
          //console.log(JSON.stringify(this.arrayData))
          this[l] = false;
          this.loader = null;
        },
        (error) => {
          console.log(error);
        }
      );
      this.$refs.inputPreview.value = "";
    },

    addOrderNumber() {
      var temp = new Set();
      // for(const i of this.arrayData){
      //     temp.add(i.Handle)
      // }
      for (var i = 0; i < this.arrayData.length; i++) {
        temp.add(this.arrayData[i]["Order Name"]);
      }
      var temp2 = Array.from(temp);

      this.total_orders = temp2.length;

      for (let j = 0; j < this.arrayData.length; j++) {
        if (j == 0) {
          this.arrayData[j]["OrderNo"] = j;
        } else if (
          this.arrayData[j]["Order Name"] == this.arrayData[j - 1]["Order Name"]
        ) {
          this.arrayData[j]["OrderNo"] = this.arrayData[j - 1].OrderNo;
        } else {
          this.arrayData[j]["OrderNo"] = this.arrayData[j - 1].OrderNo + 1;
        }
      }
    },

    async sendAPI(arr) {
      console.log("sendAPI-length: ", arr.length);

      var currentSession = await this.$root.$refs.App.currentSession(
        "dialog-pre-process-order-sendAPI"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await fetch(this.link, {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify({
            platform: "Shopify",
            total_orders: this.total_orders,
            upload_id: this.timeStamp,
            orders: arr,
          }),
        })
          .then((response) => response.json())
          .then((data) =>
            console.log("dialog-pre-process-order-response: ", data)
          )
          .catch((error) => console.log("Err: ", error));
      } else {
        console.log(
          "currentSession dialog-pre-process-order-sendAPI-undefined: ",
          currentSession
        );
      }

      // console.log(JSON.stringify(response));
    },

    async uploadData() {
      const l = this.loader;
      this[l] = !this[l];
      this.loadBtn = true;

      var maxPerAPI = 1000;
      var count = 0;
      var temp = [];

      for (var i = 0; i < this.arrayData.length; i++) {
        if (
          count > maxPerAPI &&
          this.arrayData[i]["Order Name"] != this.arrayData[i - 1]["Order Name"]
        ) {
          console.log(i);
          this.percent = Math.round((i / (this.arrayData.length - 1)) * 100);
          await this.sendAPI(temp);
          temp = [];
          count = 0;
        } else if (i == this.arrayData.length - 1) {
          //console.log(this.arrayData[i])
          this.percent = Math.round((i / (this.arrayData.length - 1)) * 100);
          console.log("Finish: ", i);
          await temp.push(this.arrayData[i]);
          this.sendAPI(temp);
          temp = [];
          count = 0;
        } else {
          count += 1;
        }
        temp.push(this.arrayData[i]);
        //console.log(temp)
      }

      (this.selectedFile = null), (this.arrayData = []);

      this[l] = false;
      this.loader = null;
      this.loadBtn = false;
      this.$root.$refs.order.showAlert(
        "preprocessing-order",
        this.total_orders
      );
    },

    cancelData() {
      this.selectedFile = [];
      this.arrayData = [];
      this.$refs.inputPreview.value = "";
      const l = this.loader;
      this[l] = false;
      this.loader = null;
      this.$root.$refs.order.turnOffDialog();
    },

    check() {
      console.log("this.loader: ", this.loader);
      console.log("inputFile: ", this.$refs.inputPreview.value);
      console.log("selectedFile", this.selectedFile);
      console.log("arrayData", this.arrayData);
      console.log("input", this.$refs.inputPreview.value);
    },
  },

  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>